import { IBalance } from 'src/app/models/balance.interface';


export interface IBalanceState {
    balance: IBalance;
}

export const initialBalanceState: IBalanceState = {
    balance: null
};
